import "./ChallengeInfo.scss";
const ChallengeInfo = ({ challengeName }) => {
  return <div className="challenge-info">Challenge: {challengeName}</div>;
};
export default ChallengeInfo;
